import { useEffect, useMemo } from 'react';
import { useIoContext } from '~/contexts';
export const useReportInvalidStanfordTaxMappings = (sources)=>{
    const { browser } = useIoContext();
    const reportedIds = useMemo(()=>new Set(), []);
    useEffect(()=>{
        sources.forEach((param)=>{
            let { id, integrations } = param;
            const invalid = integrations.invalidStanfordTaxMapping();
            if (invalid && !reportedIds.has(id)) {
                reportedIds.add(id);
                browser.reportError(new Error("Invalid StanfordTax mapping read on ".concat(id, ": ").concat(JSON.stringify(invalid))));
            }
        });
    }, [
        sources,
        reportedIds
    ]);
};
